/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MergeSources200ResponseData } from './MergeSources200ResponseData';
import {
    MergeSources200ResponseDataFromJSON,
    MergeSources200ResponseDataFromJSONTyped,
    MergeSources200ResponseDataToJSON,
    MergeSources200ResponseDataToJSONTyped,
} from './MergeSources200ResponseData';

/**
 * 
 * @export
 * @interface MergeSources200Response
 */
export interface MergeSources200Response {
    /**
     * 
     */
    data: MergeSources200ResponseData;
}

/**
 * Check if a given object implements the MergeSources200Response interface.
 */
export function instanceOfMergeSources200Response(value: object): value is MergeSources200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function MergeSources200ResponseFromJSON(json: any): MergeSources200Response {
    return MergeSources200ResponseFromJSONTyped(json, false);
}

export function MergeSources200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeSources200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': MergeSources200ResponseDataFromJSON(json['data']),
    };
}

export function MergeSources200ResponseToJSON(json: any): MergeSources200Response {
    return MergeSources200ResponseToJSONTyped(json, false);
}

export function MergeSources200ResponseToJSONTyped(value?: MergeSources200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MergeSources200ResponseDataToJSON(value['data']),
    };
}

